import { Injectable, signal } from '@angular/core';
import { TestFindingService } from './test-finding.service';

/**
 * Fuente única del estado de visibilidad de los botones flotantes de soporte.
 *
 * La allowlist de administración vive **solo** en el backend
 * (`IssueReporting:AdminEmails`); acá únicamente se consulta "¿puedo administrar?".
 */
@Injectable({ providedIn: 'root' })
export class SupportAccessService {
  readonly canManage = signal(false);
  readonly pendingCount = signal(0);
  readonly myCount = signal(0);

  constructor(private findings: TestFindingService) {}

  refresh(): void {
    this.findings.getMyCount().subscribe({
      next: n => this.myCount.set(n ?? 0),
      error: () => this.myCount.set(0)
    });

    this.findings.canManage().subscribe({
      next: ok => {
        this.canManage.set(!!ok);
        if (ok) {
          this.findings.getPendingCount().subscribe({
            next: p => this.pendingCount.set(p ?? 0),
            error: () => this.pendingCount.set(0)
          });
        } else {
          this.pendingCount.set(0);
        }
      },
      error: () => { this.canManage.set(false); this.pendingCount.set(0); }
    });
  }

  get showMyReports(): boolean { return this.myCount() > 0; }
  get showAdmin(): boolean { return this.canManage() && this.pendingCount() > 0; }
}
